import './TicketListItem.scss';
import { useDispatch, useSelector } from "react-redux";
import TicketDetailedView from '../../TicketDetailedView/TicketDetailedView';
import { setSelectedTicket, updateTicket } from "../../../../slices/TicketSlice";

function TicketListItem({ ticket }) {

  const dispatch = useDispatch();
  const id = ticket?.id;
  const title = ticket?.title;
  const status = ticket?.status;

  const selectedTicket = useSelector(state => state.tickets.selectedTicket);
  const isOpen = selectedTicket?.id === ticket.id;

  function handleClick() {
    if (!ticket) return;
    dispatch(setSelectedTicket(ticket));

    if (isOpen) {
      dispatch(updateTicket()); // close if already open
      //dispatch(setSelectedTicket(null));
    } else {
      dispatch(setSelectedTicket(ticket)); // open this ticket
    }
  }


  const TicketId = ({ id }) => {
    const missing = id === null || id === undefined || id === '';
    return (
      <p className="ticket-id">{missing ? 'N/A' : id}</p>
    );
  };

  const TicketTitle = ({ title }) => {
    return (
      <p className="ticket-title">{title ?? 'Untitled Ticket'}</p>
    );
  };

  const TicketStatus = ({ status }) => {
    const normalizedStatus = (status || "")
  .toString()
  .toLowerCase()
  .replaceAll("_", " ")
  .trim();

    let statusClass = 'status-unknown';
    if (normalizedStatus === 'open') statusClass = 'status-open';
    else if (normalizedStatus === 'in progress') statusClass = 'status-in-progress';
    else if (normalizedStatus === 'closed') statusClass = 'status-closed';
    else if (normalizedStatus === 'resolved') statusClass = 'status-resolved';
    else if (normalizedStatus === 'blocked') statusClass = 'status-blocked';
    return (
      <p className={`ticketstatus ${statusClass}`}>
        {status ?? 'Unknown'}
      </p>
    );
  };

  return (
    <div className="ticketlistitem-container">

      <button className="ticketlistitem" onClick={handleClick} type="button" data-testid="ticket-list-item-button">
        <div className="title-label">Ticket Title:</div>
        <TicketTitle title={title} data-testid="ticket-title"/>

        <div className="bottom-content">
          <div className="id-container">
            <div className="id-label">Ticket ID: </div>
            <TicketId id={id} data-testid="ticket-id"/>
          </div>

          <div className="status-container">
            <div className="status-label">Status: </div>
            <TicketStatus status={status} data-testid="ticket-status"/>
          </div>
        </div>
      </button>


      {isOpen && (
        <div className="ticketdetailedview-container">
          <TicketDetailedView onClose={() => dispatch(setSelectedTicket(null))} data-testid="ticket-detailed-view"/>
        </div>
      )}

    </div>
    
  );
}

export default TicketListItem;